import { TeamDataType } from '@/types/TeamDataType'

export const TeamData: TeamDataType = [
  {
    image: '/images/team/navin.png',
    name: 'Navin Vethanayagam',
    title: 'Chief Brain',
    about:
      'Navin first joined IQ.wiki formerly Everipedia as a founding team member at the age of 19, gaining experience over the years in community management, marketing, press, and international business. Navin has an HBA from Ivey Business School.',
    socials: {
      iqWiki: 'https://iq.wiki/wiki/navin-vethanayagam',
      twitter: 'https://twitter.com/NavV96',
    },
  },
  {
    image: '/images/team/ted.png',
    name: 'Theodor Forselius',
    title: 'Co-founder',
    about:
      'Theodor Forselius is a Swedish entrepreneur and programmer. He co-founded IQ.wiki at the age of 19. He currently serves as CEO of Brainfund which aims to advance the development of technologies in the education, AI and fintech sector. Brainfund is also the parent company of IQ.wiki.',
    socials: {
      iqWiki: 'https://iq.wiki/wiki/theodor-forselius',
      twitter: 'https://twitter.com/TeddeF',
    },
  },
  {
    image: '/images/team/travis.png',
    name: 'Travis Moore',
    title: 'Co-founder',
    about:
      'Travis Moore is an Italian-American computer programmer, angel investor, and entrepreneur from Thousand Oaks, a suburb of Los Angeles. He co-founded IQ.wiki formerly Everipedia after graduating from UCLA with degrees in Molecular Biology, Biochemistry, and Neuroscience in 2011.',
    socials: {
      iqWiki: 'https://iq.wiki/wiki/travis-moore',
      twitter: 'https://twitter.com/travismo123',
      linkedin: 'https://www.linkedin.com/pub/travis-moore/5a/510/692',
    },
  },
  {
    image: '/images/team/sam.png',
    name: 'Sam Kazemian',
    title: 'Co-founder',
    about:
      'Sam Kazemian is an Iranian-American Internet entrepreneur and programmer. His journey in crypto started after he put together a homemade CPU + GPU mining rig in his UCLA dorm. His passion for the industry led him to integrate blockchain technology into an online knowledge base for the first time in history',
    socials: {
      iqWiki: 'https://iq.wiki/wiki/sam-kazemian',
      twitter: 'https://twitter.com/samkazemian',
    },
  },
  {
    image: '/images/team/violetta.png',
    name: 'Violetta Ziborova',
    title: 'Content Manager',
    about:
      'Violetta first joined IQ.wiki formerly Everipedia in 2017, and has spent several years managing IQ.wiki’s content and mentoring IQ.wiki’s community of editors.',
    socials: {
      iqWiki: 'https://iq.wiki/wiki/violetta-ziborova',
    },
  },
  {
    image: '/images/team/kevin.png',
    name: 'Kevin Wang',
    title: 'Director Business of Development in China',
    about:
      'Kevin Wang is an experienced Chinese technology executive. He manages IQ.wiki’s partnerships, marketing, and growth in China. He previously served as the President of Shenzhen Uninet Technology Co.',
    socials: {
      iqWiki: 'https://iq.wiki/wiki/kevin-wang',
    },
  },
  {
    image: '/images/team/andy.png',
    name: 'Andy Cho',
    title: 'Director of Business Development',
    about:
      'Andy Cho first joined IQ.wiki formerly Everipedia as the company’s Director of Communications in South Korea. After several years of managing key exchange and partner relationships in Korea, he was promoted to Director of Business Development.',
    socials: {
      iqWiki: 'https://iq.wiki/wiki/andy-cho',
    },
  },
  {
    image: '/images/team/robertto.png',
    name: 'Roberto Dobrescu',
    title: 'Director of Operations',
    about:
      'Roberto Dobrescu, Business Developer, is an experienced Swedish entrepreneur. He was previously the Chief Technology Officer at IM production, a company specializing in LED screens.',
    socials: {
      iqWiki: 'https://iq.wiki/wiki/roberto-dobrescu',
    },
  },
  {
    image: '/images/team/justin-moore.png',
    name: 'Justin Moore',
    title: 'Senior Software Engineer',
    about:
      'Justin Moore is an experienced software architect and full-stack developer with over a decade of experience. In June 2021, he joined the IQ.wiki team as a Senior Software Engineer.',
    socials: {
      iqWiki: 'https://iq.wiki/wiki/justin-moore',
      linkedin: 'https://www.linkedin.com/in/justin-moore-83b31758/',
    },
  },
  {
    image: '/images/team/suchet.png',
    name: 'Suchet Dhindsa',
    title: 'Chief Operating and Financial Officer',
    about:
      'Suchet Dhindsa is a Norwegian economist, entrepreneur, and investor. Suchet has 10 years of experience in global expansion strategy, venture capital and emerging technologies.',
    socials: {
      iqWiki: 'https://iq.wiki/wiki/justin-moore',
    },
  },
  {
    image: '/images/team/kesar.png',
    name: 'César Rodríguez',
    title: 'Chief Technology Officer',
    about:
      'A talented engineer, Cesar has more than 16 years of experience as a senior software engineer. Cesar has a Master’s Degree in computer science from IES La Carballeira.',
    socials: {
      iqWiki: 'https://iq.wiki/wiki/cesar-rodriguez',
      twitter: 'https://twitter.com/kesarito',
      linkedin: 'https://www.linkedin.com/in/cesarrodriguez2',
    },
  },
]
